import moment from "moment";

const dateConversion = (date: string, format: string) => {
    return moment(date).format(format);
}

const validateDateIsBeetween = (startDate: Date, endDate: Date, date: string) => {
    return moment(date).isBetween(moment(startDate).subtract(1, 'days'), moment(endDate).add(1, 'days'));
}

const validateDateWithInNextDays = (date: string, days: number) => {
  const startDate = moment();
  const endDate = moment().add(days, 'days');
  return moment(date).isBetween(moment(startDate).subtract(1, 'days'), moment(endDate).add(1, 'days'));
}


const sortDataByDate = (data: any, key: string, direction: string) => {
  const sortedData = data.sort((a: any, b: any) => {
        
    const dateA = a[key] ? moment(a[key]) : null;
        const dateB = b[key] ? moment(b[key]) : null;
      
        if (dateA === null && dateB === null) {
          return 0; // Both null, keep original order
        }
        if (dateA === null) {
          return 1; // Nulls go to the end
        }
        if (dateB === null) {
          return -1; // Nulls go to the end
        }
      
        if (direction === "asc") {
            return dateA.valueOf() - dateB.valueOf(); // Ascending order Dates
        } else {
            return dateB.valueOf() - dateA.valueOf(); // Descending order Dates
        }
        
      });

      return sortedData;
}

export {
    dateConversion,
    validateDateIsBeetween,
    validateDateWithInNextDays,
    sortDataByDate
}